import React, { useEffect, useState } from 'react';
import { StyledConnectAccountSteps } from './ConnectAccountStepsStyles';
import Select from 'react-select';
import Button from '../../../molecules/Button';
import { useForm } from '../../../molecules/Form';
import Field from '../../Field';
import Form from '../../../molecules/Form/Form';
import verifyDots from '../../../../assets/verify-dots.png';
import verifiedIcon from '../../../../assets/verified-icon.png';
import linkedinService from '../../../../services/linkedinService';
import { proxyCountries } from '../../../Constant';
import Toast from '../../../molecules/Toast';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../../Context/authContext';
import CenterModal from '../../../molecules/Modal/CenterModal';
import Loaders from '../../Loaders';

const proxtTypes = [
  {
    label: 'HTTP',
    value: 'HTTP',
  },
  {
    label: 'HTTPS',
    value: 'HTTPS',
  },
];
const Proxy = ({ setStep, onClose, setAccountData, accountData, activeProfile, proxyLoading, setProxyLoading }) => {
  const [form] = useForm();
  const [selectProxy, setSelectProxy] = useState('houdiny');
  const [isOwnProxy, setIsOwnProxy] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const { user, refetch } = useContextHook(AuthContext, v => ({
    user: v.user,
    refetch: v.refetch,
  }));

  // Get default country based on user's country or fallback to US
  const getDefaultCountry = userData => {
    const userCountry = userData?.data?.country || userData?.country;
    if (userCountry) {
      // Try to find match by full country name (label) first, then by country code (value)
      const foundCountry = proxyCountries.find(
        c =>
          c.label?.toLowerCase() === userCountry.toLowerCase() ||
          c.value?.toUpperCase() === userCountry.toUpperCase() ||
          c.value?.toLowerCase() === userCountry.toLowerCase(),
      );
      if (foundCountry) {
        return foundCountry;
      }
    }
    // Default fallback to US
    return proxyCountries.find(c => c.value === 'US');
  };

  const [value, setValue] = useState(() => getDefaultCountry(user));

  // Update country when user data changes
  useEffect(() => {
    if (user) {
      const defaultCountry = getDefaultCountry(user);
      setValue(defaultCountry);
    }
  }, [user]);

  const changeHandler = value => {
    setValue(value);
  };

  async function handleSubmit(e) {
    setAccountData(prev => ({
      ...prev,
      proxy: { ...e, proxy_type: e?.proxy_type?.value, country: selectProxy === 'houdiny' ? value?.value : '' },
    }));
    // if (selectProxy === 'own') {
    //   setSelectProxy('verify-proxy');
    //   setTimeout(() => {
    //     setSelectProxy('verified');
    //   }, 5000);
    // } else if(selectProxy === 'houdiny' ||selectProxy === 'verified') {
    //   setStep(3);
    // }

    try {
      setProxyLoading(true);
      setLoginError(false);
      const payload = {
        cookies: [],
        country: value?.value,
        profileId: accountData?.profile?.profileId || activeProfile?.id,
      };

      const res = await linkedinService.linkedinLogin(payload);
      if (res.success) {
        Toast({
          type: 'success',
          message: res.message || 'LinkedIn account connected successfully',
        });

        const cloudBrowserUrl = res?.data?.cloud_browser_url;
        const profileId = res?.data?.profile_id;

        setAccountData(prev => ({
          ...prev,
          cloud_browser_url: cloudBrowserUrl,
          profileId: profileId,
        }));

        setStep(3);
      } else {
        setLoginError(true);
        Toast({
          type: 'error',
          message: res?.message || 'LinkedIn login failed',
        });
      }
    } catch (error) {
      setLoginError(true);
      Toast({
        type: 'error',
        message: error?.message || 'LinkedIn login failed',
      });
    } finally {
      setProxyLoading(false);
    }
  }

  useEffect(() => {
    if (selectProxy === 'own' && isOwnProxy) {
      form.setFieldRules('proxy_type', [{ required: true }]);
      form.setFieldRules('host', [{ required: true }]);
      form.setFieldRules('port', [{ required: true }]);
      form.setFieldRules('login', [{ required: true }]);
      form.setFieldRules('password', [{ required: true }]);
    } else {
      form.setFieldRules('proxy_type', [{ required: false }]);
      form.setFieldRules('host', [{ required: false }]);
      form.setFieldRules('port', [{ required: false }]);
      form.setFieldRules('login', [{ required: false }]);
      form.setFieldRules('password', [{ required: false }]);
    }
  }, [isOwnProxy]);
  return (
    <>
      <StyledConnectAccountSteps ContentCenter={selectProxy === 'verify-proxy' || selectProxy === 'verified'}>
        {(selectProxy === 'houdiny' || selectProxy === 'own') && (
          <span className="heading">Choose a proxy option to setup your LinkedIn account</span>
        )}

        <Form form={form} >
          {(selectProxy === 'houdiny' || selectProxy === 'own') && (
            <div className="houdiny-proxy">
              <div className="proxy-holder">
                <div
                  className={selectProxy === 'houdiny' ? 'radio active' : 'radio'}
                  onClick={() => {
                    setSelectProxy('houdiny');
                    setIsOwnProxy(false);
                  }}
                />
                <div className="content-holder">
                  <div
                    className="label-holder"
                    onClick={() => {
                      setSelectProxy('houdiny');
                      setIsOwnProxy(false);
                    }}>
                    <span className="label">Use Houdiny AI proxy</span>
                    <span className="text">
                      It’s reliable option - Houdiny AI automatically monitors IP availability and switches it if broken
                    </span>
                  </div>

                  <div
                    className={selectProxy === 'houdiny' ? 'form-hook-country-field active' : 'form-hook-country-field'}>
                    <span className="label">Country</span>
                    <Select
                      classNamePrefix="react-select"
                      options={proxyCountries}
                      value={value || null}
                      onChange={changeHandler}
                      menuPosition="fixed"
                      formatOptionLabel={country => (
                        <div className="flag-holder">
                          <img src={`https://flagcdn.com/w40/${country.value.toLowerCase()}.png`} alt={country.label} />
                          <span>{country.label}</span>
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="proxy-holder">
              <div
                className={selectProxy === 'own' ? 'radio active' : 'radio'}
                onClick={() => {
                  setSelectProxy('own');
                  setIsOwnProxy(true);
                }}
              />
              <div className="content-holder">
                <div
                  className="label-holder"
                  onClick={() => {
                    setSelectProxy('own');
                    setIsOwnProxy(true);
                  }}>
                  <span className="label">Use my own proxy</span>
                  <span className="text">
                    Empowers you with a full control to setup a specific country and city for your account
                  </span>
                </div>

                <div className={selectProxy === 'own' ? 'own-proxy active' : 'own-proxy'}>
                  <div className="input-holder">
                    <Form.Item
                      type="select"
                      label="Proxy Type"
                      selectSm
                      rounded
                      options={proxtTypes}
                      name="proxy_type"
                      rules={[
                        {
                          message: ' Proxy type is required',
                        },
                      ]}>
                      <Field />
                    </Form.Item>
                    <Form.Item
                      type="text"
                      label="Host"
                      inputSm
                      rounded
                      name="host"
                      placeholder="Host"
                      rules={[
                        {
                          message: ' Host is required',
                        },
                      ]}>
                      <Field />
                    </Form.Item>
                    <Form.Item
                      label="Port"
                      type="text"
                      inputSm
                      rounded
                      name="port"
                      placeholder="Port"
                      rules={[
                        {
                          message: ' Port is required',
                        },
                      ]}>
                      <Field />
                    </Form.Item>
                  </div>
                  <Form.Item
                    label="Login"
                    type="text"
                    inputSm
                    rounded
                    name="login"
                    placeholder="Login"
                    rules={[
                      {
                        message: ' Login is required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    label="Password"
                    type="password"
                    inputSm
                    rounded
                    name="password"
                    placeholder="Password"
                    rules={[
                      {
                        message: 'Password is required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>
                </div>
              </div>
            </div> */}
            </div>
          )}

          {selectProxy === 'verify-proxy' && (
            <div className="verify-proxy">
              <img src={verifyDots} alt="verifyDots" width={156} height={37} />
              <span className="heading">Verifying...</span>
              <span className="text">
                We’re checking your DNS records. This may take a few minutes depending on your <br /> DNS provider.
              </span>
            </div>
          )}
          {selectProxy === 'verified' && (
            <div className="verified">
              <img src={verifiedIcon} alt="verifyDots" width={104} height={104} />
              <span className="heading">Proxy Verified</span>
              <span className="text">
                Your domain is now ready to send emails. You can start adding email <br /> accounts under this domain.
              </span>
            </div>
          )}
          <div className="btn-holder">
            <div className="btn-wrap">
              <Button rounded variant="outline" width="155px" type="button" onClick={() => { onClose(); refetch() }}>
                Cancel
              </Button>
            </div>
            <div className={loginError ? 'btn-wrap-two error-btn' : 'btn-wrap-two'}>
              {loginError && (
                <Button
                  rounded
                  variant="outline"
                  width="155px"
                  type="button"
                  loader={proxyLoading}
                  disabled={proxyLoading}
                  onClick={handleSubmit}>
                  Retry
                </Button>
              )}
              <Button
                rounded
                variant="darkBlue"
                loader={proxyLoading}
                disabled={proxyLoading}
                type="submit"
                onClick={handleSubmit}
                width={selectProxy === 'verified' ? '250px' : '155px'}>
                {selectProxy === 'houdiny'
                  ? 'Next'
                  : selectProxy === 'own'
                    ? 'Verify Proxy'
                    : selectProxy === 'verify-proxy'
                      ? '...processing'
                      : 'Connect LinkedIn Account'}
              </Button>
            </div>
          </div>
        </Form>
      </StyledConnectAccountSteps >
    </>
  );
};

export default Proxy;
